import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import LogoAnimated from '../logo_animated';
import LogoText from '../logo_text';

import './logo_loader.scss';

const CLASS_NAME = 'logo-loader';

const LogoLoader = ({ blackBg, fixed, grayBg, subText, withSubText }) => (
  <div
    className={classnames(`${CLASS_NAME}-content`, {
      '-fixed': fixed,
      '-with-black-bg': blackBg,
      '-with-gray-bg': grayBg,
    })}
  >
    <LogoAnimated />
    <LogoText />
    {withSubText && <p className={`${CLASS_NAME}__text`}>{subText}</p>}
  </div>
);

LogoLoader.propTypes = {
  blackBg: PropTypes.bool,
  fixed: PropTypes.bool,
  grayBg: PropTypes.bool,
  subText: PropTypes.string,
  withSubText: PropTypes.bool,
};

LogoLoader.defaultProps = {
  blackBg: false,
  fixed: false,
  grayBg: false,
  subText: 'Connecting your account...',
  withSubText: true,
};

export default LogoLoader;
